// extracted by mini-css-extract-plugin
export default {"footerSection":"FooterSection_footerSection__LAx1l","subscribeFormWrap":"FooterSection_subscribeFormWrap__MciGe"};